module.exports = __webpack_public_path__ + "media/promo/advent/images/garland-1-1-57fd8414301a806da2b00532188077ae.png";